import React from 'react';
import S from 'StyledInstantWinGameCard.js';
import {redirect} from 'utilsHelper.js';
import classNames from 'classnames';

const InstantWinGameCard = (game) => {

    const instantGamesRoute = '/instantWinGames'

    const openGame = () => {
        game.active && redirect(`${instantGamesRoute}/${game.provider}/${game.name}/${game.gameId}`) 
    }

    return (
       <S.GameCard onClick={() => openGame()}>
            <S.GameImage className={classNames({'active': game.active})} style={{backgroundImage: `url(${game.image})`}}></S.GameImage>
            <S.CardName>{game.name}</S.CardName>
       </S.GameCard>
    )
}

export default InstantWinGameCard;